<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3><span v-show="!create">修改证书</span><span v-show="create">新增证书</span></h3>
      </el-col>
    </el-row>
    <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
    <div style="max-width: 800px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
        <el-row>
          <el-col :span="12">
            <el-form-item label="证书ID" prop="appId">
              <el-input ref="ipt01" v-model="form.appId" placeholder="请输入证书ID" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书KEY" prop="appKey">
              <el-input ref="ipt01" v-model="form.appKey" placeholder="请输入证书KEY" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="APP算法" prop="appSign">
              <el-input ref="ipt02" v-model="form.appSign" placeholder="请输入APP算法" maxlength="10" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="财政服务地址" prop="financeUrl">
              <el-input ref="ipt02" v-model="form.financeUrl" placeholder="请输入财政服务地址" maxlength="200" required show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签名服务器厂商" prop="signServer">
              <el-select v-model="form.signServer" placeholder="请选择">
                <el-option v-for="item in signOptions" :key="item.value" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签名服务器地址" prop="signServerIp">
              <el-input ref="ipt03" v-model="form.signServerIp" placeholder="请输入签名服务器地址" maxlength="50" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签名服务器端口号" prop="signServerPort">
              <el-input ref="ipt03" v-model="form.signServerPort" placeholder="请输入签名服务器端口号" maxlength="10" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签名算法" prop="sign">
              <el-input ref="ipt03" v-model="form.sign" placeholder="请输入签名算法" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证书编号" prop="certificateNumber">
              <el-input ref="ipt03" v-model="form.certificateNumber" placeholder="请输入证书编号" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书名称" prop="certName">
              <el-input ref="ipt03" v-model="form.certName" placeholder="请输入证书名称" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="公开密钥密码学标准" prop="cryptographyStandard">
              <el-input ref="ipt03" v-model="form.cryptographyStandard" placeholder="请输入公开密钥密码学标准" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="X.509证书颁发者名称" prop="x509IssuerName">
              <el-input ref="ipt03" v-model="form.x509IssuerName" placeholder="请输入X.509证书颁发者名称" maxlength="100" show-word-limit></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期起" prop="validityDateBgn">
              <el-date-picker placeholder="选择调用日期止" v-model="form.validityDateBgn" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="validityDateEnd">
              <el-date-picker placeholder="选择调用日期止" v-model="form.validityDateEnd" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入账ID" prop="accAppId">
              <el-input ref="ipt01" v-model="form.accAppId" placeholder="请输入入账ID" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入账KEY" prop="accAppKey">
              <el-input ref="ipt01" v-model="form.accAppKey" placeholder="请输入入账KEY" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入账算法" prop="accAppSign">
              <el-input ref="ipt02" v-model="form.accAppSign" placeholder="请输入入账算法" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入账地址" prop="accApiUrl">
              <el-input ref="ipt02" v-model="form.accApiUrl" placeholder="请输入入账地址" maxlength="200" required show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="启用状态" prop="isValid" required>
              <el-select v-model="form.isValid">
                <el-option label="启用 " value="Y"></el-option>
                <el-option label="禁用" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from "lodash"

let _kits, _form
export default {
  props: ["entity"],
  data() {
    var checkDate = (rule, value, callback) => {
      if (form.validityDateBgn != "" && form.validityDateEnd != ""
        && form.validityDateBgn > form.validityDateEnd) {
        callback(new Error("有效期起不能大于有效期至"));
      } else {
        callback();
      }
    };
    let create = !this.entity.id
    let form = {
      agencyCode: this.entity.agencyCode,
      isValid: "Y",
      id: this.entity.id
    }
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      einvtypeCodeOptions: [],
      create,
      form,
      formRules: {
        appId: [{
          required: true,
          message: "请输入证书ID",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        appKey: [{
          required: true,
          message: "请输入证书KEY",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        appSign: [{
          required: true,
          message: "请输入APP算法",
          trigger: "blur"
        },
        {
          max: 10,
          message: "最多10个字符",
          trigger: "blur"
        }
        ],
        financeUrl: [{
          required: true,
          message: "请输入财政服务地址",
          trigger: "blur"
        },
        {
          max: 200,
          message: "最多200个字符",
          trigger: "blur"
        }
        ],
        signServer: [{
          required: true,
          message: "请选择签名服务器厂商",
          trigger: "blur"
        }
        ],
        signServerIp: [{
          required: true,
          message: "请输入签名验证服务器地址",
          trigger: "blur"
        },
        {
          max: 50,
          message: "最多50个字符",
          trigger: "blur"
        }
        ],
        signServerPort: [{
          required: true,
          message: "请输入签名验证服务器端口号",
          trigger: "blur"
        },
        {
          max: 10,
          message: "最多10个字符",
          trigger: "blur"
        }
        ],
        sign: [{
          required: true,
          message: "请输入签名验证服务器加密算法",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        certificateNumber: [{
          required: true,
          message: "请输入证书编号",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        certName: [{
          required: true,
          message: "请输入证书名称",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        x509IssuerName: [{
          required: true,
          message: "请输入X.509证书颁发者名称",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        cryptographyStandard: [{
          required: true,
          message: "请输入公开密钥密码学标准",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        validityDateBgn: [{
          required: true,
          message: "请选择有效期起",
          trigger: "blur"
        }, {
          validator: checkDate,
          trigger: "blur"
        }
        ],
        validityDateEnd: [{
          validator: checkDate,
          trigger: "blur"
        }
        ],
         accAppId: [{
          required: true,
          message: "请输入入账ID",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        accAppKey: [{
          required: true,
          message: "请输入入账KEY",
          trigger: "blur"
        },
        {
          max: 100,
          message: "最多100个字符",
          trigger: "blur"
        }
        ],
        accAppSign: [{
          required: true,
          message: "请输入入账算法",
          trigger: "blur"
        },
        {
          max: 10,
          message: "最多10个字符",
          trigger: "blur"
        }
        ],
        accApiUrl: [{
          required: true,
          message: "请输入入账地址",
          trigger: "blur"
        },
        {
          max: 200,
          message: "最多200个字符",
          trigger: "blur"
        }
        ],
      },
      signOptions: [],
      jsDms: []
    }
    console.log("data is ", data)
    return data
  },
  methods: {
    onBack() {
      this.$emit("back")
    },
    onSave() {
      _form.submit();
    }
  },
  created() {
    _kits = this.$kits()
    _kits.api.call(
      "GETCOLLECTION", {
      "collectionId": "signKeyEnumCollection"
    },
      result => {
        if (result.returnCode == "0000") {
          console.log(result.data);
          this.signOptions = result.data;
        } else {
          this.$message.error(result.returnMsg);
        }
      }
    );
    if (!this.create) {
      _kits.api.call(
        "QUERYAGENCYKEYBYID", {
        id: this.entity.id
      },
        result => {
          console.log(result);
          if (result.returnCode == "0000") {
            this.form = JSON.parse(JSON.stringify(result.data))
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    }
  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: this.create ? "SAVEAGENCYKEY" : "UPDATEAGENCYKEY"
    })
    //*
    setTimeout(() => {
      _kits.page.foucus("ipt01")
      this.showLoading = false
      this.showTooltip = true
    }, 300)
  }
}
</script>
